import { useContext } from 'react';
import { DeathCauseChartsDataContext } from '../contexts/DeathCauseChartsDataContext';

export const useDeathCauseChartsDataContext = () => {
    return useContext(DeathCauseChartsDataContext);
};
